import { path } from 'ramda';


export const getAlerts = path(['alerts', 'alerts']);
export const getAlertsStat = path(['alerts', 'alertsStatistics']);
